module.exports = __webpack_public_path__ + "img/rating-icon-1.ecccad39.svg";